import { PaymentStatus } from '@/api/ariadne/__generated_types__/apollo';
import {
  PAYMENT_STATUS_TO_USER_STRING_MAP,
  TOP_LEVEL_TOT_VIEW_STATUS_COLOR_PALETTE_MAP,
} from '@/top-level-tot/constants';
import { ICellRendererFunc } from '@ag-grid-community/core';
import { AGGridColoredCellRenderer } from 'deckard-ui/dist/components/AGGridTable/cell-renderers/colored-cell/ag-grid-colored-cell-renderer';
import { renderToString } from 'react-dom/server';

export const StatusCellRenderer: ICellRendererFunc = (params) => {
  const status = params.value as PaymentStatus;

  return renderToString(
    <AGGridColoredCellRenderer
      label={PAYMENT_STATUS_TO_USER_STRING_MAP[status]}
      colorPalette={TOP_LEVEL_TOT_VIEW_STATUS_COLOR_PALETTE_MAP[status]}
    />
  );
};
